// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__p44p6","subTitleBold":"BoxSubTitle_subTitleBold__b-Yuq"};